module.exports = __webpack_public_path__ + "03_short_gray.432c4bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_short_gray.png
// module id = O5IG
// module chunks = 0